import { useState } from 'react';
import { Popover } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
import { POPOVER_OVERLAP_ALIGN } from '../constants';
import DateRangeFields from '../WorkOrderDatePicker/DateRangeFields';
import styles from './WorkOrderFilter.module.scss';

const SELECT_CARET = <CaretDownFilled aria-hidden />;
const SUMMARY_FORMAT = 'MMM D';
// Overlaps the trigger, nudged up a little (px, as antd's align offset expects).
const DATE_POPOVER_ALIGN = { ...POPOVER_OVERLAP_ALIGN, offset: [0, -4] };

interface FilterDateValueProps {
  value: [string, string];
  onChange: (value: [string, string]) => void;
}

// Collapsed like the other selects; the FROM / TO box opens over it (Images 6, 13, 14).
const FilterDateValue = ({ value, onChange }: FilterDateValueProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fromIso, toIso] = value;
  const summary = fromIso && toIso ? `${dayjs(fromIso).format(SUMMARY_FORMAT)}-${dayjs(toIso).format(SUMMARY_FORMAT)}` : 'Select date';

  const handleClose = () => setIsOpen(false);

  const dateFields = (
    <div className={styles.filterDateField} role="group" aria-label="Set date">
      <button type="button" className={styles.filterDateHeader} onClick={handleClose}>
        Select Date
        {SELECT_CARET}
      </button>
      <DateRangeFields value={value} onChange={onChange} />
    </div>
  );

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger="click"
      placement="bottomLeft"
      align={DATE_POPOVER_ALIGN}
      arrow={false}
      overlayClassName={styles.filterDateOverlay}
      destroyTooltipOnHide
      content={dateFields}
    >
      <button type="button" className={styles.filterDateTrigger} aria-haspopup="dialog">
        <span className={styles.filterDateSummary}>{summary}</span>
        {SELECT_CARET}
      </button>
    </Popover>
  );
};

export default FilterDateValue;
